import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ChevronLeft, ChevronRight } from "lucide-react";

const PrimaEDopo = () => {
  const [slideIndex, setSlideIndex] = useState(0);
  const totalSlides = 5;

  const nextSlide = () => {
    setSlideIndex((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setSlideIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight") nextSlide();
      if (e.key === "ArrowLeft") prevSlide();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div className="min-h-screen bg-[#040817] text-[#ede7d8] flex flex-col items-center justify-start px-4 py-8">
      {/* Barra superiore */}
      <div className="w-full max-w-4xl flex justify-between items-center py-4 mb-4 border-b border-[#D4AF37]/20">
        <Link to="/" className="text-lg font-bold text-[#f1d26b] flex items-center gap-2 hover:opacity-90">
          <Sparkles className="w-5 h-5" />
          <span>Il Genio in Vacanza</span>
        </Link>
        <Link
          to="/"
          className="px-5 py-2 rounded-full font-bold text-xs md:text-sm bg-gradient-to-r from-[#d4af37] to-[#f1d26b] text-[#0b1437] shadow-[0_4px_15px_rgba(212,175,55,0.35)] hover:scale-105 transition-transform"
        >
          Entra nel sito ➔
        </Link>
      </div>

      {/* Contenitore Slideshow */}
      <div className="relative w-full max-w-4xl">
        {/* Frecce Desktop */}
        <button
          onClick={prevSlide}
          className="hidden md:flex absolute -left-16 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-[#0b1437]/90 border border-[#d4af37] text-[#f1d26b] items-center justify-center text-xl hover:bg-[#d4af37] hover:text-[#0b1437] transition-all shadow-lg z-20 cursor-pointer"
          title="Precedente"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>

        <button
          onClick={nextSlide}
          className="hidden md:flex absolute -right-16 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-[#0b1437]/90 border border-[#d4af37] text-[#f1d26b] items-center justify-center text-xl hover:bg-[#d4af37] hover:text-[#0b1437] transition-all shadow-lg z-20 cursor-pointer"
          title="Successiva"
        >
          <ChevronRight className="w-6 h-6" />
        </button>

        {/* Card Contenuto */}
        <div className="w-full bg-[#0b1437] border border-[#d4af37]/40 rounded-3xl overflow-hidden shadow-[0_24px_50px_rgba(0,0,0,0.8),0_0_30px_rgba(212,175,55,0.12)]">
          <div className="px-6 py-3.5 bg-[#0f1c4a] border-b border-[#d4af37]/25 flex justify-between items-center text-xs md:text-sm font-bold text-[#f1d26b]">
            <span className="uppercase tracking-wider">
              {slideIndex === 0 && "✨ Il Nuovo Modo di Viaggiare"}
              {slideIndex === 1 && "🏨 Prenotazione Voli & Hotel"}
              {slideIndex === 2 && "🍴 Ristoranti & Aperture Verificate"}
              {slideIndex === 3 && "✈️ Voli & Logistica Sincronizzata"}
              {slideIndex === 4 && "✨ Mettiti Comodo"}
            </span>
            <span className="text-[11px] font-extrabold text-[#d4af37] bg-[#d4af37]/10 border border-[#d4af37]/30 px-3 py-1 rounded-full">
              {slideIndex + 1} / 5
            </span>
          </div>

          {/* Slide 1 */}
          {slideIndex === 0 && (
            <div className="p-8 md:p-12 text-center bg-[radial-gradient(circle_at_center,#12204f_0%,#0b1437_100%)]">
              <div className="inline-block px-3 py-1 rounded border border-[#d4af37]/50 bg-[#d4af37]/20 text-[#f1d26b] text-xs font-bold uppercase tracking-wider mb-4">
                ✨ Il Nuovo Modo di Viaggiare
              </div>
              <h1 className="text-2xl md:text-4xl font-extrabold text-[#ede7d8] leading-tight">
                Organizzare un Viaggio:<br />
                <span className="text-[#f1d26b]">Come lo facevi prima vs Con il Genio</span>
              </h1>
              <p className="text-[#94a3b8] text-sm md:text-base max-w-xl mx-auto mt-3">
                Dalle 20 schede aperte e l'ansia di perdere il volo, all'itinerario perfetto con prenotazione in 1 click.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto my-8">
                <div className="border-2 border-red-500/80 rounded-2xl overflow-hidden bg-[#070d24]">
                  <img src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=800" alt="Caos schede" className="w-full h-44 object-cover" />
                  <div className="bg-[#070d24]/95 text-red-300 p-2.5 text-xs md:text-sm font-bold">
                    ✕ Prima: 20 schede e confusione
                  </div>
                </div>
                <div className="border-2 border-[#d4af37] rounded-2xl overflow-hidden bg-[#070d24]">
                  <img src="https://images.unsplash.com/photo-1488646953014-85cb44e25828?q=80&w=800" alt="Relax viaggio" className="w-full h-44 object-cover" />
                  <div className="bg-[#070d24]/95 text-[#f1d26b] p-2.5 text-xs md:text-sm font-bold">
                    ✓ Con il Genio: Tutto pronto e verificato
                  </div>
                </div>
              </div>

              <div className="flex justify-center items-center gap-4 text-xs md:text-sm">
                <button onClick={nextSlide} className="text-[#d4af37] font-bold hover:underline cursor-pointer">
                  👉 Clicca per vedere le differenze
                </button>
              </div>
            </div>
          )}

          {/* Slide 2 */}
          {slideIndex === 1 && (
            <div className="grid grid-cols-1 md:grid-cols-2 min-h-[460px]">
              <div className="p-6 md:p-8 bg-[#070d24] border-b md:border-b-0 md:border-r border-white/10 flex flex-col justify-between">
                <div>
                  <div className="inline-block px-2.5 py-1 rounded text-[11px] font-bold uppercase tracking-wider bg-red-500/15 text-red-400 border border-red-500/30 mb-3">
                    ✕ Metodo Tradizionale
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-red-300 mb-3">Rimbalzi continui tra decine di siti</h3>
                  <div className="w-full h-44 rounded-xl overflow-hidden mb-4 border border-white/10">
                    <img src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=800&auto=format&fit=crop" alt="Stress comparatori" className="w-full h-full object-cover" />
                  </div>
                  <ul className="space-y-2.5 text-xs md:text-sm text-slate-300">
                    <li className="flex items-start gap-2"><span className="text-red-500 font-extrabold">✕</span> Salti tra comparatori, motori di volo e portali hotel.</li>
                    <li className="flex items-start gap-2"><span className="text-red-500 font-extrabold">✕</span> Perdi il filo tra date, scali e orari calcolati.</li>
                    <li className="flex items-start gap-2"><span className="text-red-500 font-extrabold">✕</span> Scegli hotel distanti dalle tappe previste spendendo di più.</li>
                  </ul>
                </div>
                <div className="mt-4 pt-3 border-t border-white/10 text-xs font-semibold text-red-400">
                  Risultato: Confusione, rincari e ore di tempo sprecate.
                </div>
              </div>

              <div className="p-6 md:p-8 bg-[#0c1842] flex flex-col justify-between">
                <div>
                  <div className="inline-block px-2.5 py-1 rounded text-[11px] font-bold uppercase tracking-wider bg-[#d4af37]/20 text-[#f1d26b] border border-[#d4af37]/50 mb-3">
                    ✓ Con Il Genio in Vacanza
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-[#f1d26b] mb-3">Blocca Volo e Hotel con un click</h3>
                  <div className="w-full h-44 rounded-xl overflow-hidden mb-4 border border-white/10">
                    <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=800&auto=format&fit=crop" alt="Hotel elegante" className="w-full h-full object-cover" />
                  </div>
                  <ul className="space-y-2.5 text-xs md:text-sm text-slate-300">
                    <li className="flex items-start gap-2"><span className="text-[#d4af37] font-extrabold">✓</span> Link diretti integrati per le migliori combinazioni volo + hotel.</li>
                    <li className="flex items-start gap-2"><span className="text-[#d4af37] font-extrabold">✓</span> Strutture geolocalizzate vicine alle attrazioni del tuo piano.</li>
                    <li className="flex items-start gap-2"><span className="text-[#d4af37] font-extrabold">✓</span> Tariffe più competitive del web pronte da bloccare subito.</li>
                  </ul>
                </div>
                <div className="mt-4 pt-3 border-t border-white/10 text-xs font-semibold text-[#f1d26b]">
                  Risultato: Itinerario e prenotazioni risolti insieme.
                </div>
              </div>
            </div>
          )}

          {/* Slide 3 */}
          {slideIndex === 2 && (
            <div className="grid grid-cols-1 md:grid-cols-2 min-h-[460px]">
              <div className="p-6 md:p-8 bg-[#070d24] border-b md:border-b-0 md:border-r border-white/10 flex flex-col justify-between">
                <div>
                  <div className="inline-block px-2.5 py-1 rounded text-[11px] font-bold uppercase tracking-wider bg-red-500/15 text-red-400 border border-red-500/30 mb-3">
                    ✕ Metodo Tradizionale
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-red-300 mb-3">La beffa della serranda abbassata</h3>
                  <div className="w-full h-44 rounded-xl overflow-hidden mb-4 border border-white/10">
                    <img src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5?q=80&w=800" alt="Ristorante chiuso" className="w-full h-full object-cover" />
                  </div>
                  <ul className="space-y-2.5 text-xs md:text-sm text-slate-300">
                    <li className="flex items-start gap-2"><span className="text-red-500 font-extrabold">✕</span> Ti fidi di un articolo trovato su un vecchio blog online.</li>
                    <li className="flex items-start gap-2"><span className="text-red-500 font-extrabold">✕</span> Arrivi affamato alle 21:30 ed è il giorno di chiusura settimanale.</li>
                    <li className="flex items-start gap-2"><span className="text-red-500 font-extrabold">✕</span> Oppure fa cucina solo a pranzo e la sera trovi chiuso.</li>
                  </ul>
                </div>
                <div className="mt-4 pt-3 border-t border-white/10 text-xs font-semibold text-red-400">
                  Risultato: Serata rovinata e ripieghi veloci di fortuna.
                </div>
              </div>

              <div className="p-6 md:p-8 bg-[#0c1842] flex flex-col justify-between">
                <div>
                  <div className="inline-block px-2.5 py-1 rounded text-[11px] font-bold uppercase tracking-wider bg-[#d4af37]/20 text-[#f1d26b] border border-[#d4af37]/50 mb-3">
                    ✓ Con Il Genio in Vacanza
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-[#f1d26b] mb-3">Verifica in tempo reale con Google Places</h3>
                  <div className="w-full h-44 rounded-xl overflow-hidden mb-4 border border-white/10">
                    <img src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=800" alt="Ristorante accogliente aperto" className="w-full h-full object-cover" />
                  </div>
                  <ul className="space-y-2.5 text-xs md:text-sm text-slate-300">
                    <li className="flex items-start gap-2"><span className="text-[#d4af37] font-extrabold">✓</span> Controllo automatico dei turni di riposo per giorno esatto.</li>
                    <li className="flex items-start gap-2"><span className="text-[#d4af37] font-extrabold">✓</span> Validazione della fascia oraria effettiva (pranzo vs cena).</li>
                    <li className="flex items-start gap-2"><span className="text-[#d4af37] font-extrabold">✓</span> Link istantaneo su Google Maps e rating verificato.</li>
                  </ul>
                </div>
                <div className="mt-4 pt-3 border-t border-white/10 text-xs font-semibold text-[#f1d26b]">
                  Risultato: Tavolo sicuro e zero brutte sorprese.
                </div>
              </div>
            </div>
          )}

          {/* Slide 4 */}
          {slideIndex === 3 && (
            <div className="grid grid-cols-1 md:grid-cols-2 min-h-[460px]">
              <div className="p-6 md:p-8 bg-[#070d24] border-b md:border-b-0 md:border-r border-white/10 flex flex-col justify-between">
                <div>
                  <div className="inline-block px-2.5 py-1 rounded text-[11px] font-bold uppercase tracking-wider bg-red-500/15 text-red-400 border border-red-500/30 mb-3">
                    ✕ Metodo Tradizionale
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-red-300 mb-3">Corse disperate al gate e ansia perenne</h3>
                  <div className="w-full h-44 rounded-xl overflow-hidden mb-4 border border-white/10">
                    <img src="/corsa_gate.jpg" alt="Passeggero in corsa con trolley al gate dell'aeroporto" className="w-full h-full object-cover" />
                  </div>
                  <ul className="space-y-2.5 text-xs md:text-sm text-slate-300">
                    <li className="flex items-start gap-2"><span className="text-red-500 font-extrabold">✕</span> Atterri alle 13:00 e prenoti visite alle 14:00 dimenticando i tempi di sbarco.</li>
                    <li className="flex items-start gap-2"><span className="text-red-500 font-extrabold">✕</span> Salti il pranzo per ritardi nei bagagli o nei collegamenti.</li>
                    <li className="flex items-start gap-2"><span className="text-red-500 font-extrabold">✕</span> L'ultimo giorno corri col batticuore per non perdere il volo.</li>
                  </ul>
                </div>
                <div className="mt-4 pt-3 border-t border-white/10 text-xs font-semibold text-red-400">
                  Risultato: Più stress durante il viaggio che al lavoro.
                </div>
              </div>

              <div className="p-6 md:p-8 bg-[#0c1842] flex flex-col justify-between">
                <div>
                  <div className="inline-block px-2.5 py-1 rounded text-[11px] font-bold uppercase tracking-wider bg-[#d4af37]/20 text-[#f1d26b] border border-[#d4af37]/50 mb-3">
                    ✓ Con Il Genio in Vacanza
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-[#f1d26b] mb-3">Ritmo calibrato al minuto sui tuoi voli</h3>
                  <div className="w-full h-44 rounded-xl overflow-hidden mb-4 border border-white/10">
                    <img src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?q=80&w=800&auto=format&fit=crop" alt="Volo sereno" className="w-full h-full object-cover" />
                  </div>
                  <ul className="space-y-2.5 text-xs md:text-sm text-slate-300">
                    <li className="flex items-start gap-2"><span className="text-[#d4af37] font-extrabold">✓</span> Giorno 1 calcola 1h30m per sbarco, bagagli e transfer hotel.</li>
                    <li className="flex items-start gap-2"><span className="text-[#d4af37] font-extrabold">✓</span> Visite e pasti programmati solo a check-in concluso.</li>
                    <li className="flex items-start gap-2"><span className="text-[#d4af37] font-extrabold">✓</span> Ultimo giorno protetto con transfer anticipato al gate.</li>
                  </ul>
                </div>
                <div className="mt-4 pt-3 border-t border-white/10 text-xs font-semibold text-[#f1d26b]">
                  Risultato: Ritmi fluidi e zero corse al gate.
                </div>
              </div>
            </div>
          )}

          {/* Slide 5 */}
          {slideIndex === 4 && (
            <div className="p-8 md:p-14 text-center bg-[radial-gradient(circle_at_center,#12204f_0%,#0b1437_100%)]">
              <div className="inline-block px-3 py-1 rounded border border-[#d4af37]/50 bg-[#d4af37]/20 text-[#f1d26b] text-xs font-bold uppercase tracking-wider mb-4">
                🧞‍♂️ Mettiti Comodo
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold text-[#ede7d8] leading-tight">
                Basta passare le serate a organizzare viaggi.
              </h2>
              <p className="text-slate-300 text-sm md:text-base max-w-lg mx-auto my-4 leading-relaxed">
                Lascia fare al Genio: pianifica l'itinerario perfetto, trova i voli, prenota i migliori hotel e parti senza pensieri.
              </p>

              <div className="mt-8">
                <Link
                  to="/"
                  className="inline-block px-8 py-4 rounded-full font-bold text-base bg-gradient-to-r from-[#d4af37] to-[#f1d26b] text-[#0b1437] shadow-[0_10px_30px_rgba(212,175,55,0.45)] hover:scale-105 transition-transform"
                >
                  🚀 Inizia Ora Gratis su Il Genio in Vacanza
                </Link>
              </div>
              <div className="mt-6 text-xs md:text-sm font-mono text-[#d4af37]">
                www.genioinvacanza.it
              </div>
            </div>
          )}
        </div>

        {/* Controlli Mobile */}
        <div className="flex md:hidden justify-between items-center mt-4 px-2">
          <button
            onClick={prevSlide}
            className="px-4 py-2 rounded-xl bg-[#0b1437] border border-[#d4af37] text-[#f1d26b] font-bold text-xs flex items-center gap-1 cursor-pointer"
          >
            <ChevronLeft className="w-4 h-4" /> Precedente
          </button>
          <button
            onClick={nextSlide}
            className="px-4 py-2 rounded-xl bg-[#d4af37] text-[#0b1437] font-bold text-xs flex items-center gap-1 cursor-pointer"
          >
            Successiva <ChevronRight className="w-4 h-4" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-3 mt-6">
          {[...Array(totalSlides)].map((_, i) => (
            <button
              key={i}
              onClick={() => setSlideIndex(i)}
              className={`w-3.5 h-3.5 rounded-full transition-all duration-300 cursor-pointer ${
                slideIndex === i
                  ? "bg-[#f1d26b] scale-125 shadow-[0_0_12px_rgba(241,210,107,0.8)]"
                  : "bg-[#d4af37]/25 border border-[#d4af37]/50"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrimaEDopo;
